/* TRU KAVA tk27 · global header behaviour: header-height variable, scrolled state, mobile menu, live cart count */
(function(){
  'use strict';
  var de = document.documentElement;
  var sec = document.querySelector('.tkg-hdr-sec'), hdr = document.getElementById('tkg-header');
  function setH(){
    var h = sec ? Math.round(sec.getBoundingClientRect().height) : 0;
    de.style.setProperty('--tk27-hdr-h', h + 'px');
  }
  setH();
  if(sec && 'ResizeObserver' in window) new ResizeObserver(setH).observe(sec);
  window.addEventListener('resize', setH);
  window.addEventListener('load', setH);
  function onScroll(){ if(hdr) hdr.classList.toggle('tkg-scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', onScroll, {passive: true}); onScroll();

  /* mobile menu: lives outside the sticky header's stacking context */
  var host = document.querySelector('.tkg-mnav-host');
  if(host && host.parentNode !== document.body) document.body.appendChild(host);
  var nav = document.getElementById('tkg-mnav'), btn = document.querySelector('.tkg-menu-btn');
  if(nav && btn){
    var closeB = nav.querySelector('.tkg-close'), opener = null;
    function focusables(){ return [].slice.call(nav.querySelectorAll('a[href],button:not([disabled])')); }
    function setNav(open){
      nav.classList.toggle('tkg-open', open);
      btn.setAttribute('aria-expanded', String(open));
      de.classList.toggle('tkg-nav-open', open);
      if(open){ opener = document.activeElement; setTimeout(function(){ if(closeB) closeB.focus(); }, 30); }
      else if(opener && opener.focus){ opener.focus(); }
    }
    btn.addEventListener('click', function(){ setNav(true); });
    if(closeB) closeB.addEventListener('click', function(){ setNav(false); });
    nav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ setNav(false); }); });
    document.addEventListener('keydown', function(e){
      if(!nav.classList.contains('tkg-open')) return;
      if(e.key === 'Escape'){ setNav(false); return; }
      if(e.key === 'Tab'){
        var f = focusables(), a = f[0], z = f[f.length - 1];
        if(e.shiftKey && document.activeElement === a){ e.preventDefault(); z.focus(); }
        else if(!e.shiftKey && document.activeElement === z){ e.preventDefault(); a.focus(); }
      }
    });
    window.addEventListener('resize', function(){ if(window.innerWidth > 1180 && nav.classList.contains('tkg-open')) setNav(false); });
  }

  /* live cart count after AJAX adds */
  document.addEventListener('tk27:cart-added', function(e){
    var c = e.detail && e.detail.cart;
    if(c) document.querySelectorAll('[data-tk27-cart-count]').forEach(function(el){ el.textContent = c.item_count; el.hidden = !c.item_count; });
  });
})();
